import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';
import { useActionDispatcher } from '../../hooks';
import CustomerForm from './CustomerForm';
import {
  createCustomerRequest,
  initCustomerRequest,
  resetCurrentCustomer,
} from '../../store/modules/customers/actions';
import {
  isCustomerPersistent,
  selectCustomer,
} from '../../store/modules/customers/selectors';

const CustomerCreate = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initCustomerRequest());
    return () => {
      dispatch(resetCurrentCustomer());
    };
  }, [dispatch]);

  const createCustomer = useActionDispatcher(createCustomerRequest);

  const persistent = useSelector(isCustomerPersistent);

  const customer = useSelector(selectCustomer);

  useEffect(() => {
    if (persistent) {
      dispatch(replace(`/dashboard/admin/customers/${customer.data!.id}`));
    }
  }, [persistent, customer.data, dispatch]);

  return (
    <CustomerForm
      creatingMode
      record={customer}
      onSubmit={createCustomer}
    />
  );
};

export default CustomerCreate;
